import React, {Component} from 'react';
import ua from 'ua-parser-js';

import CookieStorage from '../helpers/storage/CookieStorage';

export default class AndroidAppDownloadBanner extends Component {
    constructor(props) {
        super(props);

        const agent = ua(navigator.userAgent);
        this.cookie = new CookieStorage();

        this.state = {
            isAndroid: agent.os.name === 'Android',
            userDismissed: this.cookie.readCookie('android-smartbanner-closed'),
            userInstalled: this.cookie.readCookie('android-smartbanner-installed')
        };
    }

    close = () => {
        this.cookie.createCookie('android-smartbanner-closed', true, 15);
        this.setState({
            userDismissed: true
        });
    }

    install = () => {
        this.cookie.createCookie('android-smartbanner-installed', true, 30);
        this.setState({
            userInstalled: true
        });
    }

    render() {
        if (!this.state.isAndroid || this.state.userDismissed || this.state.userInstalled) {
            return null;
        }

        return (
            <div className="rec-app-smartbanner-container">
                <button
                    className="rec-app-smartbanner-close"
                    onClick={this.close}>
                        &times;
                </button>
                <span
                    className="rec-app-smartbanner-icon"
                    style={{backgroundImage: `url('${process.env.CDN}/img/favicons/app_icon.png')`}} />
                <div className="rec-app-smartbanner-info">
                    <div className="rec-app-smartbanner-title">
                        Recreation.gov
                    </div>
                    <div className="rec-app-smartbanner-subtext">
                        Booz Allen Hamilton, Inc.
                    </div>
                    <div className="rec-app-smartbanner-subtext">
                        In Google Play
                    </div>
                </div>
                <div className="rec-app-smartbanner-open">
                    <a
                        href="https://play.google.com/store/apps/details?id=com.bah.r1smobile"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={this.install}>
                        <span className="rec-app-smartbanner-button-text">
                            OPEN
                        </span>
                    </a>
                </div>
            </div>
        )
    }
}
